import { render, staticRenderFns } from "./uploadToOss.vue?vue&type=template&id=32bc9c0c"
import script from "./uploadToOss.vue?vue&type=script&lang=js"
export * from "./uploadToOss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports